import Bootpay from "@bootpay/client-js";

// 부트페이 인증/결제 창을 강제로 닫기. 외부에서 "취소" 버튼 눌렀을 때 사용.
// 라이브러리 버전에 따라 메서드명이 다를 수 있어 defensively 호출한다.
export function dismissBootpay() {
  const fns = ["dismiss", "close", "destroy", "removeChild"];
  for (const fn of fns) {
    try { if (typeof Bootpay[fn] === "function") { Bootpay[fn](); return; } } catch {}
  }
  // 마지막 수단: DOM 에서 부트페이가 만든 iframe/wrapper 를 직접 제거
  try {
    document
      .querySelectorAll('iframe[src*="bootpay"], #bootpay, .bootpay, [id^="bootpay"], [class^="bootpay"]')
      .forEach((el) => el.parentNode?.removeChild(el));
    // 백드롭/오버레이도 정리
    document
      .querySelectorAll('[id*="bootpay"], [class*="bootpay"]')
      .forEach((el) => { try { el.parentNode?.removeChild(el); } catch {} });
    document.body.style.overflow = "";
  } catch (e) {
    console.warn("dismissBootpay DOM fallback failed:", e);
  }
}

export async function goBootpayRequest2(body) {
  const response = await Bootpay.requestPayment({
    application_id: process.env.REACT_APP_BOOTPAY,
    price: body.price,
    order_name: body.order_name,
    order_id: Date.now().toString(),
    pg: "나이스페이",
    method: "카드",
    tax_free: 0,
    user: {
      id: body.user_id,
      username: body.user_name,
      phone: body.user_phone,
      address: body.user_address,
    },
    extra: {
      open_type: "iframe",
      card_quota: "0,2,3",
      escrow: false,
    },
  });
  return response;
}

/* [DEPRECATED] Bootpay(다날) PASS 휴대폰 본인인증 — Firebase 전화인증(components/phone_auth_dialog.jsx)으로 대체.
   결제(goBootpayRequest2)와 dismissBootpay 는 변경 없이 유지.
export default async function goBootpayRequest(onSuccess) {
  const payload = {
    pg: "다날",
    method: "auth",
    order_name: "휴대폰 인증",
    authentication_id: Date.now().toString(),
    application_id: "64b76e0700be04001a77a552",
    extra: {
      app_scheme: "뚝딱이",
      open_type: "iframe",
    },
  };

  try {
    const res = await Bootpay.requestAuthentication(payload);

    const receiptId = res.data.receipt_id;
    const response = await fetch(
      `https://www.hello-research.com:3539/auth/${receiptId}`
    );
    const data = await response.json();
    onSuccess(data["authenticate_data"]);
  } catch (err) {
    console.error("Bootpay Error:", err);
  }
}
*/
